export const INSTALL_SUGGESTION_SESSION_KEY = "oaprep.installSuggestionDismissed";

function getUserAgent() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.navigator.userAgent.toLowerCase();
}

export function isIosSafari() {
  const userAgent = getUserAgent();
  const isIos = /iphone|ipad|ipod/.test(userAgent);
  const isSafari = /safari/.test(userAgent) && !/crios|fxios|edgios/.test(userAgent);
  return isIos && isSafari;
}

export function isAndroidChrome() {
  const userAgent = getUserAgent();
  return /android/.test(userAgent) && /chrome/.test(userAgent);
}

export function isStandaloneMode() {
  if (typeof window === "undefined") {
    return false;
  }
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function isMobileDevice() {
  const userAgent = getUserAgent();
  return /iphone|ipad|ipod|android|mobile/.test(userAgent);
}

export function shouldSuggestInstall() {
  if (typeof window === "undefined") {
    return false;
  }

  if (isStandaloneMode()) {
    return false;
  }

  if (!isMobileDevice()) {
    return false;
  }

  const pathname = window.location.pathname || "";
  if (pathname.startsWith("/install")) {
    return false;
  }

  return true;
}
